module.exports = __webpack_public_path__ + "img/个人管理select.cb0af8c6.svg";